import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export const SiteLayout = () => {
    const location = useLocation();

    /* Scroll to top on route change */
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
    }, [location.pathname]);

    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main id="main-content" className="flex-1 pt-20 lg:pt-24">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default SiteLayout;
